import {
    ADD_FILTER,
    REMOVE_FILTER,
    UPDATE_DEPARTMENT,
    RECEIVE_LIQUORS,
    UPDATE_FILTER,
} from '../actions/types';

const initialFilters = {
    department: '',
    search: '',
    category: [],
    brand: [],
    varietal: [],
    type: [],
    region: [],
    size: [],
    price: [],
    sort: 'A-Z',
};

const filters = (state = initialFilters, action) => {
    switch (action.type) {
        case ADD_FILTER:
            return {
                ...state,
                [action.name]: [...state[action.name], action.value],
            };
        case REMOVE_FILTER:
            return {
                ...state,
                [action.name]: state[action.name].filter(
                    (value) => value !== action.value
                ),
            };
        case UPDATE_FILTER:
            return {
                ...state,
                [action.name]: action.value,
            };
        case UPDATE_DEPARTMENT:
            return {
                ...initialFilters,
                department: action.payload,
                search: state.search,
                initialPrice: state.initialPrice,
                price: state.price,
            };
        default:
            return state;
    }
};

export default filters;
